<div class="station-selection-component">

  <div class="vertical-flex-content">

    <div class="station-groups">
      <h3 class="title">
        {{'station groups' |translate: ['tmc.station-selection-component.station-groups.title' , translationService.language]}}
      </h3>
      <app-list [selected]="selection.stationGroup">
        <ng-container *ngFor="let sg of stationGroups">
          <app-list-item [model]="sg" (click)="setSelectedStationGroup(sg)">
            <div class="station-name">
              {{ sg.name }}
            </div>
          </app-list-item>
        </ng-container>
      </app-list>
    </div>

    <div class="station-sets">
      <h3 class="title">
        {{'station sets' |translate: ['tmc.station-selection-component.station-sets.title' , translationService.language]}}
      </h3>
      <app-list [selected]="selection.stationSet" class="" *ngIf="selection.stationGroup != null">
        <ng-container *ngFor="let stationSet of selection.stationGroup.stationSets">
          <app-list-item [model]="stationSet" (click)="setSelectedStationSet(stationSet)">
            <div class="station-name">
              {{ stationSet.name }}
            </div>
          </app-list-item>
        </ng-container>
      </app-list>
    </div>

    <div class="stations">
      <h3 class="title">
        {{'stations' |translate: ['tmc.station-selection-component.stations.title' , translationService.language]}}
      </h3>
      <div class="stations-grid" *ngIf="selection.stationSet != null && includeStations">
        <ng-container *ngFor="let station of getStations(selection.stationSet)">
          <ng-container *ngIf="!station.disabled">
            <div class="grid-box" matRipple (click)="setSelectedStation(station)">
              <div class="selection-marker" *ngIf="isStationSelected(station)"></div>
              <div class="content">
                {{station.name}}
              </div>
              <div class="icon" *ngIf="station.used"><sc-icon iconClass="fa-truck"></sc-icon></div>
              <div class="icon" *ngIf="station.suspended"><sc-icon iconClass="fa-pause-circle"></sc-icon></div>
            </div>
          </ng-container>
          <ng-container *ngIf="station.disabled">
            <div class="grid-box disabled">
              <div class="content">{{station.name}}</div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>

  </div>
</div>
